import InfoIcon from '@mui/icons-material/Info'
import { Box, Paper, Stack, Typography, useTheme } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import { i18WithDefault as t } from '@shared/locales'
import { Types } from 'service-api'
import { DetailsSection, Footer, Header, OffersSection } from './receipt_details'
import { RequestDates, TReceiptInvoice } from './request_dates'
import { TSurchargeValues } from '../../shared/payment'

export const PurchaseReceipt = ({
  receipt,
  dueToday,
  isVisit,
  order,
  surchargeValues,
}: {
  receipt?: Types.ReceiptDto
  dueToday?: number | null
  isVisit?: boolean
  order?: Types.OrderClientDto | Types.OrderAdminDto
  surchargeValues?: TSurchargeValues
}) => {
  const theme = useTheme()
  const isBelowMD = useMediaQuery(theme.breakpoints.down('md'))

  return receipt ? (
    <Box>
      <Paper sx={{ p: 2, height: '100%', borderRadius: `${isBelowMD ? 0 : theme.shape.borderRadius}px` }}>
        <Header name={receipt.locationName} address={receipt.locationAddress} phone={receipt.locationPhone} />
        <RequestDates invoices={(receipt.invoices || []) as unknown as TReceiptInvoice[]} />
        <DetailsSection receipt={receipt} isVisit={isVisit} />
        <Stack px={1}>
          <OffersSection receipt={receipt} />
          <Footer receipt={receipt} dueToday={dueToday} order={order!} surchargeValues={surchargeValues} />
        </Stack>
      </Paper>
      {receipt.invoices?.some((invoice) => invoice.items?.some((item) => item.priceVaries)) && (
        <Stack direction="row" spacing={1} mt={1}>
          <InfoIcon
            sx={{
              width: '20px',
              height: '20px',
              color: theme.palette.action.active,
            }}
          />
          <Typography>{t('booking.startingAtPolicy')}</Typography>
        </Stack>
      )}
    </Box>
  ) : null
}
